import {reaction as $42h8L$reaction, toJS as $42h8L$toJS, observable as $42h8L$observable, action as $42h8L$action, computed as $42h8L$computed} from "mobx";
import {isEmpty as $42h8L$isEmpty, splitArray as $42h8L$splitArray, countBy as $42h8L$countBy, ByteSize as $42h8L$ByteSize} from "web-utility";
import * as $42h8L$idbkeyval from "idb-keyval";
import {HTTPClient as $42h8L$HTTPClient} from "koajax";
import * as $42h8L$nativefilesystemadapter from "native-file-system-adapter";
import * as $42h8L$webstreamspolyfill from "web-streams-polyfill";


function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $082ef78710a13331$exports = {};
var $80184bab4212ab17$exports = {};


var $400caf514fe4dd82$exports = {};

$parcel$export($400caf514fe4dd82$exports, "toggle", function () { return $400caf514fe4dd82$export$e03c1c3201ee8bb7; });
$parcel$export($400caf514fe4dd82$exports, "toggleNotification", function () { return $400caf514fe4dd82$export$6287f85d0f6a9342; });
$parcel$export($400caf514fe4dd82$exports, "persist", function () { return $400caf514fe4dd82$export$9a6132153fba2e0; });
$parcel$export($400caf514fe4dd82$exports, "restore", function () { return $400caf514fe4dd82$export$db239ef39aadc7fe; });
$parcel$export($400caf514fe4dd82$exports, "destroy", function () { return $400caf514fe4dd82$export$b1fb4cac938035f7; });


var $400caf514fe4dd82$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
function $400caf514fe4dd82$export$e03c1c3201ee8bb7(property) {
    return (origin, {})=>function(...data) {
            return $400caf514fe4dd82$var$__awaiter(this, void 0, void 0, function*() {
                var value = Reflect.get(this, property);
                Reflect.set(this, property, typeof value === "number" ? ++value : true);
                try {
                    return yield origin.apply(this, data);
                } finally{
                    value = Reflect.get(this, property);
                    Reflect.set(this, property, typeof value === "number" ? --value : false);
                }
            });
        };
}
function $400caf514fe4dd82$export$6287f85d0f6a9342(message) {
    return (origin, {})=>function(...data) {
            return $400caf514fe4dd82$var$__awaiter(this, void 0, void 0, function*() {
                const notification = Notification.requestPermission().then((permission)=>{
                    if (permission === "granted") return new Notification(typeof message === "function" ? message(this) : message);
                });
                try {
                    return yield origin.apply(this, data);
                } finally{
                    notification.then((notification)=>notification === null || notification === void 0 ? void 0 : notification.close());
                }
            });
        };
}
const $400caf514fe4dd82$var$PersistKeys = new WeakMap();
function $400caf514fe4dd82$export$9a6132153fba2e0(patcher = {}) {
    return ({}, { name: name, addInitializer: addInitializer })=>{
        addInitializer(function() {
            const list = $400caf514fe4dd82$var$PersistKeys.get(this) || [];
            list.push(Object.assign(Object.assign({}, patcher), {
                key: name.toString()
            }));
            $400caf514fe4dd82$var$PersistKeys.set(this, list);
        });
    };
}

function $400caf514fe4dd82$export$db239ef39aadc7fe(classInstance, storeKey) {
    return $400caf514fe4dd82$var$__awaiter(this, void 0, void 0, function*() {
        var _a;
        const { get: load, set: save } = yield $42h8L$idbkeyval, list = $400caf514fe4dd82$var$PersistKeys.get(classInstance) || [], restoredData = {};
        for (const { key: key, get: get, set: set } of list){
            const itemKey = `${storeKey}-${key}`;
            const value = yield load(itemKey);
            const patchedValue = (_a = get === null || get === void 0 ? void 0 : get(value)) !== null && _a !== void 0 ? _a : value;
            if (patchedValue != null) {
                Reflect.set(classInstance, key, patchedValue);
                restoredData[key] = patchedValue;
            }
            (0, $42h8L$reaction)(()=>classInstance[key], (value)=>{
                const patchedValue = set === null || set === void 0 ? void 0 : set(value);
                return save(itemKey, patchedValue !== null && patchedValue !== void 0 ? patchedValue : (0, $42h8L$toJS)(value));
            });
        }
        if ((0, $42h8L$isEmpty)(restoredData)) return;
        console.group(`Restored ${storeKey}`);
        console.table(restoredData);
        console.groupEnd();
    });
}

function $400caf514fe4dd82$export$b1fb4cac938035f7(classInstance, storeKey) {
    return $400caf514fe4dd82$var$__awaiter(this, void 0, void 0, function*() {
        const { del: del } = yield $42h8L$idbkeyval, list = $400caf514fe4dd82$var$PersistKeys.get(classInstance) || [];
        for (const { key: key } of list){
            const itemKey = `${storeKey}-${key}`;
            yield del(itemKey);
        }
    });
}


$parcel$exportWildcard($082ef78710a13331$exports, $80184bab4212ab17$exports);
$parcel$exportWildcard($082ef78710a13331$exports, $400caf514fe4dd82$exports);


var $16892940cfb7bd51$exports = {};

$parcel$export($16892940cfb7bd51$exports, "BaseModel", function () { return $16892940cfb7bd51$export$d12e20a4eec10acf; });
$parcel$export($16892940cfb7bd51$exports, "BaseListModel", function () { return $16892940cfb7bd51$export$673dbc4a8d0cb20a; });


var $16892940cfb7bd51$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $16892940cfb7bd51$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $16892940cfb7bd51$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $16892940cfb7bd51$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $16892940cfb7bd51$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
let $16892940cfb7bd51$export$d12e20a4eec10acf = (()=>{
    var _a, _BaseModel_downloading_accessor_storage, _BaseModel_uploading_accessor_storage;
    let _instanceExtraInitializers = [];
    let _downloading_decorators;
    let _downloading_initializers = [];
    let _downloading_extraInitializers = [];
    let _uploading_decorators;
    let _uploading_initializers = [];
    let _uploading_extraInitializers = [];
    let _clear_decorators;
    return _a = class BaseModel {
        get downloading() {
            return $16892940cfb7bd51$var$__classPrivateFieldGet(this, _BaseModel_downloading_accessor_storage, "f");
        }
        set downloading(value) {
            $16892940cfb7bd51$var$__classPrivateFieldSet(this, _BaseModel_downloading_accessor_storage, value, "f");
        }
        get uploading() {
            return $16892940cfb7bd51$var$__classPrivateFieldGet(this, _BaseModel_uploading_accessor_storage, "f");
        }
        set uploading(value) {
            $16892940cfb7bd51$var$__classPrivateFieldSet(this, _BaseModel_uploading_accessor_storage, value, "f");
        }
        clear() {
            this.downloading = this.uploading = 0;
        }
        constructor(){
            _BaseModel_downloading_accessor_storage.set(this, ($16892940cfb7bd51$var$__runInitializers(this, _instanceExtraInitializers), $16892940cfb7bd51$var$__runInitializers(this, _downloading_initializers, 0)));
            _BaseModel_uploading_accessor_storage.set(this, ($16892940cfb7bd51$var$__runInitializers(this, _downloading_extraInitializers), $16892940cfb7bd51$var$__runInitializers(this, _uploading_initializers, 0)));
            $16892940cfb7bd51$var$__runInitializers(this, _uploading_extraInitializers);
        }
    }, _BaseModel_downloading_accessor_storage = new WeakMap(), _BaseModel_uploading_accessor_storage = new WeakMap(), (()=>{
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
        _downloading_decorators = [
            (0, $42h8L$observable)
        ];
        _uploading_decorators = [
            (0, $42h8L$observable)
        ];
        _clear_decorators = [
            (0, $42h8L$action)
        ];
        $16892940cfb7bd51$var$__esDecorate(_a, null, _downloading_decorators, {
            kind: "accessor",
            name: "downloading",
            static: false,
            private: false,
            access: {
                has: (obj)=>"downloading" in obj,
                get: (obj)=>obj.downloading,
                set: (obj, value)=>{
                    obj.downloading = value;
                }
            },
            metadata: _metadata
        }, _downloading_initializers, _downloading_extraInitializers);
        $16892940cfb7bd51$var$__esDecorate(_a, null, _uploading_decorators, {
            kind: "accessor",
            name: "uploading",
            static: false,
            private: false,
            access: {
                has: (obj)=>"uploading" in obj,
                get: (obj)=>obj.uploading,
                set: (obj, value)=>{
                    obj.uploading = value;
                }
            },
            metadata: _metadata
        }, _uploading_initializers, _uploading_extraInitializers);
        $16892940cfb7bd51$var$__esDecorate(_a, null, _clear_decorators, {
            kind: "method",
            name: "clear",
            static: false,
            private: false,
            access: {
                has: (obj)=>"clear" in obj,
                get: (obj)=>obj.clear
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    })(), _a;
})();
/**
 * This basic class is a middle class, which isn't for direct using
 */ let $16892940cfb7bd51$export$673dbc4a8d0cb20a = (()=>{
    var _a, _BaseListModel_currentOne_accessor_storage;
    let _classSuper = $16892940cfb7bd51$export$d12e20a4eec10acf;
    let _instanceExtraInitializers = [];
    let _currentOne_decorators;
    let _currentOne_initializers = [];
    let _currentOne_extraInitializers = [];
    let _clearCurrent_decorators;
    let _updateOne_decorators;
    let _getOne_decorators;
    let _deleteOne_decorators;
    return _a = class BaseListModel extends _classSuper {
        get currentOne() {
            return $16892940cfb7bd51$var$__classPrivateFieldGet(this, _BaseListModel_currentOne_accessor_storage, "f");
        }
        set currentOne(value) {
            $16892940cfb7bd51$var$__classPrivateFieldSet(this, _BaseListModel_currentOne_accessor_storage, value, "f");
        }
        // @observable
        // validity: InvalidMessage<D> = {};
        static createNested(parentId) {
            const Model = this;
            const store = new Model();
            store.baseURI = store.baseURI.replace(/:\w+/, parentId + "");
            return store;
        }
        clearCurrent() {
            this.currentOne = {};
        // this.validity = {};
        }
        clear() {
            super.clear();
            this.clearCurrent();
        }
        updateOne(data, id) {
            return $16892940cfb7bd51$var$__awaiter(this, void 0, void 0, function*() {
                const { body: body } = yield id ? this.client.patch(`${this.baseURI}/${id}`, data) : this.client.post(this.baseURI, data);
                return this.currentOne = body;
            });
        }
        getOne(id) {
            return $16892940cfb7bd51$var$__awaiter(this, void 0, void 0, function*() {
                const { body: body } = yield this.client.get(`${this.baseURI}/${id}`);
                return this.currentOne = body;
            });
        }
        deleteOne(id) {
            return $16892940cfb7bd51$var$__awaiter(this, void 0, void 0, function*() {
                yield this.client.delete(`${this.baseURI}/${id}`);
                if (this.currentOne[this.indexKey] === id) this.clearCurrent();
            });
        }
        constructor(){
            super(...arguments);
            Object.defineProperty(this, "indexKey", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($16892940cfb7bd51$var$__runInitializers(this, _instanceExtraInitializers), "id")
            });
            _BaseListModel_currentOne_accessor_storage.set(this, $16892940cfb7bd51$var$__runInitializers(this, _currentOne_initializers, {}));
            $16892940cfb7bd51$var$__runInitializers(this, _currentOne_extraInitializers);
        }
    }, _BaseListModel_currentOne_accessor_storage = new WeakMap(), (()=>{
        var _b;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_b = _classSuper[Symbol.metadata]) !== null && _b !== void 0 ? _b : null) : void 0;
        _currentOne_decorators = [
            (0, $42h8L$observable)
        ];
        _clearCurrent_decorators = [
            (0, $42h8L$action)
        ];
        _updateOne_decorators = [
            (0, $400caf514fe4dd82$export$e03c1c3201ee8bb7)("uploading")
        ];
        _getOne_decorators = [
            (0, $400caf514fe4dd82$export$e03c1c3201ee8bb7)("downloading")
        ];
        _deleteOne_decorators = [
            (0, $400caf514fe4dd82$export$e03c1c3201ee8bb7)("uploading")
        ];
        $16892940cfb7bd51$var$__esDecorate(_a, null, _currentOne_decorators, {
            kind: "accessor",
            name: "currentOne",
            static: false,
            private: false,
            access: {
                has: (obj)=>"currentOne" in obj,
                get: (obj)=>obj.currentOne,
                set: (obj, value)=>{
                    obj.currentOne = value;
                }
            },
            metadata: _metadata
        }, _currentOne_initializers, _currentOne_extraInitializers);
        $16892940cfb7bd51$var$__esDecorate(_a, null, _clearCurrent_decorators, {
            kind: "method",
            name: "clearCurrent",
            static: false,
            private: false,
            access: {
                has: (obj)=>"clearCurrent" in obj,
                get: (obj)=>obj.clearCurrent
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $16892940cfb7bd51$var$__esDecorate(_a, null, _updateOne_decorators, {
            kind: "method",
            name: "updateOne",
            static: false,
            private: false,
            access: {
                has: (obj)=>"updateOne" in obj,
                get: (obj)=>obj.updateOne
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $16892940cfb7bd51$var$__esDecorate(_a, null, _getOne_decorators, {
            kind: "method",
            name: "getOne",
            static: false,
            private: false,
            access: {
                has: (obj)=>"getOne" in obj,
                get: (obj)=>obj.getOne
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $16892940cfb7bd51$var$__esDecorate(_a, null, _deleteOne_decorators, {
            kind: "method",
            name: "deleteOne",
            static: false,
            private: false,
            access: {
                has: (obj)=>"deleteOne" in obj,
                get: (obj)=>obj.deleteOne
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    })(), _a;
})();


var $5766c49bacaeb5b8$exports = {};

$parcel$export($5766c49bacaeb5b8$exports, "ListModel", function () { return $5766c49bacaeb5b8$export$36e5777a1ba4b7c3; });
$parcel$export($5766c49bacaeb5b8$exports, "Buffer", function () { return $5766c49bacaeb5b8$export$a143d493d941bafc; });
$parcel$export($5766c49bacaeb5b8$exports, "Stream", function () { return $5766c49bacaeb5b8$export$6a4eb2e7fc9e8903; });




var $5766c49bacaeb5b8$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $5766c49bacaeb5b8$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $5766c49bacaeb5b8$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $5766c49bacaeb5b8$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $5766c49bacaeb5b8$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
let $5766c49bacaeb5b8$export$36e5777a1ba4b7c3 = (()=>{
    var _a, _ListModel_pageIndex_accessor_storage, _ListModel_pageSize_accessor_storage, _ListModel_filter_accessor_storage, _ListModel_totalCount_accessor_storage, _ListModel_pageList_accessor_storage, _ListModel_statistic_accessor_storage;
    let _classSuper = (0, $16892940cfb7bd51$export$673dbc4a8d0cb20a);
    let _instanceExtraInitializers = [];
    let _pageIndex_decorators;
    let _pageIndex_initializers = [];
    let _pageIndex_extraInitializers = [];
    let _pageSize_decorators;
    let _pageSize_initializers = [];
    let _pageSize_extraInitializers = [];
    let _filter_decorators;
    let _filter_initializers = [];
    let _filter_extraInitializers = [];
    let _totalCount_decorators;
    let _totalCount_initializers = [];
    let _totalCount_extraInitializers = [];
    let _pageList_decorators;
    let _pageList_initializers = [];
    let _pageList_extraInitializers = [];
    let _get_currentPage_decorators;
    let _get_pageCount_decorators;
    let _get_allItems_decorators;
    let _get_noMore_decorators;
    let _statistic_decorators;
    let _statistic_initializers = [];
    let _statistic_extraInitializers = [];
    let _clearList_decorators;
    let _restoreList_decorators;
    let _turnTo_decorators;
    let _getList_decorators;
    let _deleteOne_decorators;
    return _a = class ListModel extends _classSuper {
        get pageIndex() {
            return $5766c49bacaeb5b8$var$__classPrivateFieldGet(this, _ListModel_pageIndex_accessor_storage, "f");
        }
        set pageIndex(value) {
            $5766c49bacaeb5b8$var$__classPrivateFieldSet(this, _ListModel_pageIndex_accessor_storage, value, "f");
        }
        get pageSize() {
            return $5766c49bacaeb5b8$var$__classPrivateFieldGet(this, _ListModel_pageSize_accessor_storage, "f");
        }
        set pageSize(value) {
            $5766c49bacaeb5b8$var$__classPrivateFieldSet(this, _ListModel_pageSize_accessor_storage, value, "f");
        }
        get filter() {
            return $5766c49bacaeb5b8$var$__classPrivateFieldGet(this, _ListModel_filter_accessor_storage, "f");
        }
        set filter(value) {
            $5766c49bacaeb5b8$var$__classPrivateFieldSet(this, _ListModel_filter_accessor_storage, value, "f");
        }
        get totalCount() {
            return $5766c49bacaeb5b8$var$__classPrivateFieldGet(this, _ListModel_totalCount_accessor_storage, "f");
        }
        set totalCount(value) {
            $5766c49bacaeb5b8$var$__classPrivateFieldSet(this, _ListModel_totalCount_accessor_storage, value, "f");
        }
        get pageList() {
            return $5766c49bacaeb5b8$var$__classPrivateFieldGet(this, _ListModel_pageList_accessor_storage, "f");
        }
        set pageList(value) {
            $5766c49bacaeb5b8$var$__classPrivateFieldSet(this, _ListModel_pageList_accessor_storage, value, "f");
        }
        get currentPage() {
            return this.pageList[this.pageIndex - 1] || [];
        }
        get pageCount() {
            return Math.ceil(this.totalCount / this.pageSize) || this.pageList.length;
        }
        get allItems() {
            const pageList = (0, $42h8L$toJS)(this.pageList), { pageSize: pageSize, totalCount: totalCount } = this;
            const index = [
                ...pageList
            ].reverse().findIndex((item)=>(item === null || item === void 0 ? void 0 : item[0]) != null);
            return Array.from(pageList.slice(0, -index || Infinity), (page)=>(page === null || page === void 0 ? void 0 : page[0]) ? page : new Array(pageSize).fill({})).flat().slice(0, totalCount || 0);
        }
        get noMore() {
            return this.pageIndex * this.pageSize >= this.totalCount;
        }
        get statistic() {
            return $5766c49bacaeb5b8$var$__classPrivateFieldGet(this, _ListModel_statistic_accessor_storage, "f");
        }
        set statistic(value) {
            $5766c49bacaeb5b8$var$__classPrivateFieldSet(this, _ListModel_statistic_accessor_storage, value, "f");
        }
        clearList() {
            this.pageIndex = 0;
            this.pageSize = 10;
            this.filter = {};
            this.pageList = [];
            this.totalCount = undefined;
        }
        clear() {
            super.clear();
            this.clearList();
        }
        restoreList({ pageIndex: pageIndex = this.pageIndex + 1, pageSize: pageSize = this.pageSize, allItems: allItems = this.allItems, totalCount: totalCount = Infinity } = {}) {
            if (!allItems.length) return;
            this.pageList = (0, $42h8L$splitArray)(allItems, pageSize);
            this.pageIndex = pageIndex;
            this.pageSize = pageSize;
            this.totalCount = totalCount;
        }
        turnTo(pageIndex, pageSize = this.pageSize) {
            this.pageIndex = pageIndex;
            if (this.pageSize !== pageSize) this.pageList = (0, $42h8L$splitArray)(this.allItems, this.pageSize = pageSize);
            return this;
        }
        /**
             * @protected
             */ loadNewPage(pageIndex, pageSize, filter) {
            return $5766c49bacaeb5b8$var$__awaiter(this, void 0, void 0, function*() {
                const { pageData: pageData, totalCount: totalCount } = yield this.loadPage(pageIndex, pageSize, filter);
                this.pageSize = pageSize;
                const list = [
                    ...this.pageList
                ];
                list[pageIndex - 1] = pageData;
                this.pageList = list;
                this.totalCount = totalCount != null ? isNaN(totalCount) || totalCount < 0 ? Infinity : totalCount : Infinity;
                return {
                    pageData: pageData,
                    totalCount: totalCount
                };
            });
        }
        // @action  // disabled for @override bug of MobX 6
        getList() {
            return $5766c49bacaeb5b8$var$__awaiter(this, arguments, void 0, function*(filter = this.filter, pageIndex = this.pageIndex + 1, pageSize = this.pageSize) {
                const { pageData: pageData } = yield this.loadNewPage(pageIndex, pageSize, filter);
                this.filter = filter;
                this.turnTo(pageIndex, pageSize);
                return pageData;
            });
        }
        refreshList() {
            const { filter: filter, pageSize: pageSize } = this;
            this.clearList();
            return this.getList(filter, 1, pageSize);
        }
        getAll() {
            return $5766c49bacaeb5b8$var$__awaiter(this, arguments, void 0, function*(filter = this.filter, pageSize = this.pageSize) {
                while(!this.noMore)yield this.getList(filter, undefined, pageSize);
                return this.allItems;
            });
        }
        countAll(keys_1) {
            return $5766c49bacaeb5b8$var$__awaiter(this, arguments, void 0, function*(keys, filter = this.filter, pageSize = this.pageSize) {
                const allItems = yield this.getAll(filter, pageSize);
                const statistic = Object.fromEntries(keys.map((key)=>[
                        key,
                        (0, $42h8L$countBy)(allItems, key)
                    ]));
                return this.statistic = statistic;
            });
        }
        indexOf(id) {
            const { indexKey: indexKey, allItems: allItems } = this;
            return allItems.findIndex(({ [indexKey]: ID })=>ID === id);
        }
        changeOne(data, id, patch = false) {
            const { pageIndex: pageIndex, allItems: allItems, totalCount: totalCount } = this, index = this.indexOf(id);
            if (index > -1) this.restoreList({
                pageIndex: pageIndex,
                allItems: [
                    ...allItems.slice(0, index),
                    patch ? Object.assign(Object.assign({}, allItems[index]), data) : data,
                    ...allItems.slice(index + 1)
                ],
                totalCount: totalCount
            });
        }
        updateOne(data, id) {
            const _super = Object.create(null, {
                updateOne: {
                    get: ()=>super.updateOne
                }
            });
            return $5766c49bacaeb5b8$var$__awaiter(this, void 0, void 0, function*() {
                yield _super.updateOne.call(this, data, id);
                if (id) this.changeOne(this.currentOne, id);
                return this.currentOne;
            });
        }
        removeOne(id) {
            return $5766c49bacaeb5b8$var$__awaiter(this, void 0, void 0, function*() {
                const { filter: filter, pageIndex: pageIndex, allItems: allItems } = this, index = this.indexOf(id);
                const { pageData: pageData } = yield this.loadPage(allItems.length + 1, 1, filter);
                return this.restoreList({
                    pageIndex: pageIndex,
                    allItems: [
                        ...allItems.slice(0, index),
                        ...allItems.slice(index + 1),
                        ...pageData
                    ],
                    totalCount: this.totalCount--
                });
            });
        }
        deleteOne(id) {
            const _super = Object.create(null, {
                deleteOne: {
                    get: ()=>super.deleteOne
                }
            });
            return $5766c49bacaeb5b8$var$__awaiter(this, void 0, void 0, function*() {
                yield _super.deleteOne.call(this, id);
                yield this.removeOne(id);
            });
        }
        constructor(){
            super(...arguments);
            _ListModel_pageIndex_accessor_storage.set(this, ($5766c49bacaeb5b8$var$__runInitializers(this, _instanceExtraInitializers), $5766c49bacaeb5b8$var$__runInitializers(this, _pageIndex_initializers, 0)));
            _ListModel_pageSize_accessor_storage.set(this, ($5766c49bacaeb5b8$var$__runInitializers(this, _pageIndex_extraInitializers), $5766c49bacaeb5b8$var$__runInitializers(this, _pageSize_initializers, 10)));
            _ListModel_filter_accessor_storage.set(this, ($5766c49bacaeb5b8$var$__runInitializers(this, _pageSize_extraInitializers), $5766c49bacaeb5b8$var$__runInitializers(this, _filter_initializers, {})));
            _ListModel_totalCount_accessor_storage.set(this, ($5766c49bacaeb5b8$var$__runInitializers(this, _filter_extraInitializers), $5766c49bacaeb5b8$var$__runInitializers(this, _totalCount_initializers, void 0)));
            _ListModel_pageList_accessor_storage.set(this, ($5766c49bacaeb5b8$var$__runInitializers(this, _totalCount_extraInitializers), $5766c49bacaeb5b8$var$__runInitializers(this, _pageList_initializers, [])));
            _ListModel_statistic_accessor_storage.set(this, ($5766c49bacaeb5b8$var$__runInitializers(this, _pageList_extraInitializers), $5766c49bacaeb5b8$var$__runInitializers(this, _statistic_initializers, {})));
            $5766c49bacaeb5b8$var$__runInitializers(this, _statistic_extraInitializers);
        }
    }, _ListModel_pageIndex_accessor_storage = new WeakMap(), _ListModel_pageSize_accessor_storage = new WeakMap(), _ListModel_filter_accessor_storage = new WeakMap(), _ListModel_totalCount_accessor_storage = new WeakMap(), _ListModel_pageList_accessor_storage = new WeakMap(), _ListModel_statistic_accessor_storage = new WeakMap(), (()=>{
        var _b;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_b = _classSuper[Symbol.metadata]) !== null && _b !== void 0 ? _b : null) : void 0;
        _pageIndex_decorators = [
            (0, $42h8L$observable)
        ];
        _pageSize_decorators = [
            (0, $42h8L$observable)
        ];
        _filter_decorators = [
            (0, $42h8L$observable)
        ];
        _totalCount_decorators = [
            (0, $42h8L$observable)
        ];
        _pageList_decorators = [
            (0, $42h8L$observable)
        ];
        _get_currentPage_decorators = [
            (0, $42h8L$computed)
        ];
        _get_pageCount_decorators = [
            (0, $42h8L$computed)
        ];
        _get_allItems_decorators = [
            (0, $42h8L$computed)
        ];
        _get_noMore_decorators = [
            (0, $42h8L$computed)
        ];
        _statistic_decorators = [
            (0, $42h8L$observable)
        ];
        _clearList_decorators = [
            (0, $42h8L$action)
        ];
        _restoreList_decorators = [
            (0, $42h8L$action)
        ];
        _turnTo_decorators = [
            (0, $42h8L$action)
        ];
        _getList_decorators = [
            (0, $400caf514fe4dd82$export$e03c1c3201ee8bb7)("downloading")
        ];
        _deleteOne_decorators = [
            (0, $400caf514fe4dd82$export$e03c1c3201ee8bb7)("uploading")
        ];
        $5766c49bacaeb5b8$var$__esDecorate(_a, null, _pageIndex_decorators, {
            kind: "accessor",
            name: "pageIndex",
            static: false,
            private: false,
            access: {
                has: (obj)=>"pageIndex" in obj,
                get: (obj)=>obj.pageIndex,
                set: (obj, value)=>{
                    obj.pageIndex = value;
                }
            },
            metadata: _metadata
        }, _pageIndex_initializers, _pageIndex_extraInitializers);
        $5766c49bacaeb5b8$var$__esDecorate(_a, null, _pageSize_decorators, {
            kind: "accessor",
            name: "pageSize",
            static: false,
            private: false,
            access: {
                has: (obj)=>"pageSize" in obj,
                get: (obj)=>obj.pageSize,
                set: (obj, value)=>{
                    obj.pageSize = value;
                }
            },
            metadata: _metadata
        }, _pageSize_initializers, _pageSize_extraInitializers);
        $5766c49bacaeb5b8$var$__esDecorate(_a, null, _filter_decorators, {
            kind: "accessor",
            name: "filter",
            static: false,
            private: false,
            access: {
                has: (obj)=>"filter" in obj,
                get: (obj)=>obj.filter,
                set: (obj, value)=>{
                    obj.filter = value;
                }
            },
            metadata: _metadata
        }, _filter_initializers, _filter_extraInitializers);
        $5766c49bacaeb5b8$var$__esDecorate(_a, null, _totalCount_decorators, {
            kind: "accessor",
            name: "totalCount",
            static: false,
            private: false,
            access: {
                has: (obj)=>"totalCount" in obj,
                get: (obj)=>obj.totalCount,
                set: (obj, value)=>{
                    obj.totalCount = value;
                }
            },
            metadata: _metadata
        }, _totalCount_initializers, _totalCount_extraInitializers);
        $5766c49bacaeb5b8$var$__esDecorate(_a, null, _pageList_decorators, {
            kind: "accessor",
            name: "pageList",
            static: false,
            private: false,
            access: {
                has: (obj)=>"pageList" in obj,
                get: (obj)=>obj.pageList,
                set: (obj, value)=>{
                    obj.pageList = value;
                }
            },
            metadata: _metadata
        }, _pageList_initializers, _pageList_extraInitializers);
        $5766c49bacaeb5b8$var$__esDecorate(_a, null, _get_currentPage_decorators, {
            kind: "getter",
            name: "currentPage",
            static: false,
            private: false,
            access: {
                has: (obj)=>"currentPage" in obj,
                get: (obj)=>obj.currentPage
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $5766c49bacaeb5b8$var$__esDecorate(_a, null, _get_pageCount_decorators, {
            kind: "getter",
            name: "pageCount",
            static: false,
            private: false,
            access: {
                has: (obj)=>"pageCount" in obj,
                get: (obj)=>obj.pageCount
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $5766c49bacaeb5b8$var$__esDecorate(_a, null, _get_allItems_decorators, {
            kind: "getter",
            name: "allItems",
            static: false,
            private: false,
            access: {
                has: (obj)=>"allItems" in obj,
                get: (obj)=>obj.allItems
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $5766c49bacaeb5b8$var$__esDecorate(_a, null, _get_noMore_decorators, {
            kind: "getter",
            name: "noMore",
            static: false,
            private: false,
            access: {
                has: (obj)=>"noMore" in obj,
                get: (obj)=>obj.noMore
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $5766c49bacaeb5b8$var$__esDecorate(_a, null, _statistic_decorators, {
            kind: "accessor",
            name: "statistic",
            static: false,
            private: false,
            access: {
                has: (obj)=>"statistic" in obj,
                get: (obj)=>obj.statistic,
                set: (obj, value)=>{
                    obj.statistic = value;
                }
            },
            metadata: _metadata
        }, _statistic_initializers, _statistic_extraInitializers);
        $5766c49bacaeb5b8$var$__esDecorate(_a, null, _clearList_decorators, {
            kind: "method",
            name: "clearList",
            static: false,
            private: false,
            access: {
                has: (obj)=>"clearList" in obj,
                get: (obj)=>obj.clearList
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $5766c49bacaeb5b8$var$__esDecorate(_a, null, _restoreList_decorators, {
            kind: "method",
            name: "restoreList",
            static: false,
            private: false,
            access: {
                has: (obj)=>"restoreList" in obj,
                get: (obj)=>obj.restoreList
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $5766c49bacaeb5b8$var$__esDecorate(_a, null, _turnTo_decorators, {
            kind: "method",
            name: "turnTo",
            static: false,
            private: false,
            access: {
                has: (obj)=>"turnTo" in obj,
                get: (obj)=>obj.turnTo
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $5766c49bacaeb5b8$var$__esDecorate(_a, null, _getList_decorators, {
            kind: "method",
            name: "getList",
            static: false,
            private: false,
            access: {
                has: (obj)=>"getList" in obj,
                get: (obj)=>obj.getList
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $5766c49bacaeb5b8$var$__esDecorate(_a, null, _deleteOne_decorators, {
            kind: "method",
            name: "deleteOne",
            static: false,
            private: false,
            access: {
                has: (obj)=>"deleteOne" in obj,
                get: (obj)=>obj.deleteOne
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    })(), _a;
})();
function $5766c49bacaeb5b8$export$a143d493d941bafc(Super) {
    let BufferListMixin = (()=>{
        var _a;
        let _classSuper = Super;
        let _instanceExtraInitializers = [];
        let _getList_decorators;
        return _a = class BufferListMixin extends _classSuper {
            constructor(){
                super(...arguments);
                Object.defineProperty(this, "pendingList", {
                    enumerable: true,
                    configurable: true,
                    writable: true,
                    value: ($5766c49bacaeb5b8$var$__runInitializers(this, _instanceExtraInitializers), [])
                });
            }
            clearList() {
                super.clearList();
                this.pendingList = [];
            }
            clear() {
                super.clear();
                this.clearList();
            }
            getList() {
                const _super = Object.create(null, {
                    getList: {
                        get: ()=>super.getList
                    }
                });
                return $5766c49bacaeb5b8$var$__awaiter(this, arguments, void 0, function*(filter = this.filter, pageIndex = this.pageIndex + 1, pageSize = this.pageSize) {
                    const currentIndex = pageIndex - 1;
                    if (this.pendingList[currentIndex]) {
                        const { pageData: pageData } = yield this.pendingList[currentIndex];
                        this.turnTo(pageIndex, pageSize);
                        return pageData;
                    }
                    if (this.pageList[currentIndex]) this.turnTo(pageIndex, pageSize);
                    else var list = yield _super.getList.call(this, filter, pageIndex, pageSize);
                    const nextIndex = pageIndex + 1;
                    this.pendingList[nextIndex] = this.loadNewPage(nextIndex, pageSize, filter).then((data)=>{
                        this.pendingList[nextIndex] = undefined;
                        return data;
                    });
                    return list;
                });
            }
        }, (()=>{
            var _b;
            const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_b = _classSuper[Symbol.metadata]) !== null && _b !== void 0 ? _b : null) : void 0;
            _getList_decorators = [
                (0, $42h8L$action),
                (0, $400caf514fe4dd82$export$e03c1c3201ee8bb7)("downloading")
            ];
            $5766c49bacaeb5b8$var$__esDecorate(_a, null, _getList_decorators, {
                kind: "method",
                name: "getList",
                static: false,
                private: false,
                access: {
                    has: (obj)=>"getList" in obj,
                    get: (obj)=>obj.getList
                },
                metadata: _metadata
            }, null, _instanceExtraInitializers);
            if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
                enumerable: true,
                configurable: true,
                writable: true,
                value: _metadata
            });
        })(), _a;
    })();
    return BufferListMixin;
}
function $5766c49bacaeb5b8$export$6a4eb2e7fc9e8903(Super) {
    let StreamListMixin = (()=>{
        var _a;
        let _classSuper = Super;
        let _instanceExtraInitializers = [];
        let _restoreList_decorators;
        return _a = class StreamListMixin extends _classSuper {
            constructor(){
                super(...arguments);
                Object.defineProperty(this, "stream", {
                    enumerable: true,
                    configurable: true,
                    writable: true,
                    value: $5766c49bacaeb5b8$var$__runInitializers(this, _instanceExtraInitializers)
                });
            }
            clearList() {
                super.clearList();
                this.stream = undefined;
            }
            clear() {
                super.clear();
                this.clearList();
            }
            restoreList() {
                const _super = Object.create(null, {
                    restoreList: {
                        get: ()=>super.restoreList
                    }
                });
                return $5766c49bacaeb5b8$var$__awaiter(this, arguments, void 0, function*({ filter: filter = this.filter, pageIndex: pageIndex = this.pageIndex + 1, pageSize: pageSize = this.pageSize, allItems: allItems = this.allItems, totalCount: totalCount = Infinity } = {}) {
                    _super.restoreList.call(this, {
                        pageIndex: pageIndex,
                        pageSize: pageSize,
                        allItems: allItems,
                        totalCount: totalCount
                    });
                    if (allItems.length) yield this.loadStream(filter, allItems.length);
                });
            }
            /**
                 * @protected
                 */ loadStream(filter, newCount) {
                return $5766c49bacaeb5b8$var$__awaiter(this, void 0, void 0, function*() {
                    const newList = [];
                    const stream = this.stream || (this.stream = this.openStream(filter));
                    for(let i = 0; i < newCount; i++){
                        const { done: done, value: value } = yield stream.next();
                        if (done) break;
                        newList.push(value);
                    }
                    return newList;
                });
            }
            /**
                 * @protected
                 */ loadPage(pageIndex, pageSize, filter) {
                return $5766c49bacaeb5b8$var$__awaiter(this, void 0, void 0, function*() {
                    const { totalCount: totalCount, allItems: allItems } = this, requiredCount = pageIndex * pageSize;
                    const newCount = (totalCount ? Math.min(totalCount, requiredCount) : requiredCount) - allItems.length;
                    const newList = yield this.loadStream(filter, newCount);
                    this.pageList = (0, $42h8L$splitArray)([
                        ...this.allItems,
                        ...newList
                    ], pageSize);
                    return {
                        pageData: this.pageList[pageIndex - 1] || [],
                        totalCount: this.totalCount
                    };
                });
            }
        }, (()=>{
            var _b;
            const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_b = _classSuper[Symbol.metadata]) !== null && _b !== void 0 ? _b : null) : void 0;
            _restoreList_decorators = [
                (0, $400caf514fe4dd82$export$e03c1c3201ee8bb7)("downloading")
            ];
            $5766c49bacaeb5b8$var$__esDecorate(_a, null, _restoreList_decorators, {
                kind: "method",
                name: "restoreList",
                static: false,
                private: false,
                access: {
                    has: (obj)=>"restoreList" in obj,
                    get: (obj)=>obj.restoreList
                },
                metadata: _metadata
            }, null, _instanceExtraInitializers);
            if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
                enumerable: true,
                configurable: true,
                writable: true,
                value: _metadata
            });
        })(), _a;
    })();
    return StreamListMixin;
}


var $5bda69183db6db33$exports = {};

$parcel$export($5bda69183db6db33$exports, "Downloader", function () { return $5bda69183db6db33$export$ef06e7620d37c296; });


var $71107f2a0d00cd1d$exports = {};

$parcel$export($71107f2a0d00cd1d$exports, "HTTPDownloadTask", function () { return $71107f2a0d00cd1d$export$54a5aef4e85ae85; });


var $d278b456907e9c31$exports = {};

$parcel$export($d278b456907e9c31$exports, "DownloadTask", function () { return $d278b456907e9c31$export$e9ba70c733fe1cb8; });



var $d278b456907e9c31$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $d278b456907e9c31$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $d278b456907e9c31$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $d278b456907e9c31$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $d278b456907e9c31$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $d278b456907e9c31$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $d278b456907e9c31$var$__asyncValues = undefined && undefined.__asyncValues || function(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
};

let $d278b456907e9c31$export$e9ba70c733fe1cb8 = (()=>{
    var _a, _DownloadTask_id_accessor_storage, _DownloadTask_name_accessor_storage, _DownloadTask_path_accessor_storage, _DownloadTask_fsHandle_accessor_storage, _DownloadTask_total_accessor_storage, _DownloadTask_loaded_accessor_storage, _DownloadTask_percent_accessor_storage, _DownloadTask_executing_accessor_storage, _DownloadTask_options_accessor_storage;
    var _b;
    let _instanceExtraInitializers = [];
    let _id_decorators;
    let _id_initializers = [];
    let _id_extraInitializers = [];
    let _name_decorators;
    let _name_initializers = [];
    let _name_extraInitializers = [];
    let _path_decorators;
    let _path_initializers = [];
    let _path_extraInitializers = [];
    let _fsHandle_decorators;
    let _fsHandle_initializers = [];
    let _fsHandle_extraInitializers = [];
    let _total_decorators;
    let _total_initializers = [];
    let _total_extraInitializers = [];
    let _loaded_decorators;
    let _loaded_initializers = [];
    let _loaded_extraInitializers = [];
    let _percent_decorators;
    let _percent_initializers = [];
    let _percent_extraInitializers = [];
    let _executing_decorators;
    let _executing_initializers = [];
    let _executing_extraInitializers = [];
    let _options_decorators;
    let _options_initializers = [];
    let _options_extraInitializers = [];
    let _get_totalSize_decorators;
    let _get_loadedSize_decorators;
    return _a = class DownloadTask {
        get id() {
            return $d278b456907e9c31$var$__classPrivateFieldGet(this, _DownloadTask_id_accessor_storage, "f");
        }
        set id(value) {
            $d278b456907e9c31$var$__classPrivateFieldSet(this, _DownloadTask_id_accessor_storage, value, "f");
        }
        get name() {
            return $d278b456907e9c31$var$__classPrivateFieldGet(this, _DownloadTask_name_accessor_storage, "f");
        }
        set name(value) {
            $d278b456907e9c31$var$__classPrivateFieldSet(this, _DownloadTask_name_accessor_storage, value, "f");
        }
        get path() {
            return $d278b456907e9c31$var$__classPrivateFieldGet(this, _DownloadTask_path_accessor_storage, "f");
        }
        set path(value) {
            $d278b456907e9c31$var$__classPrivateFieldSet(this, _DownloadTask_path_accessor_storage, value, "f");
        }
        get fsHandle() {
            return $d278b456907e9c31$var$__classPrivateFieldGet(this, _DownloadTask_fsHandle_accessor_storage, "f");
        }
        set fsHandle(value) {
            $d278b456907e9c31$var$__classPrivateFieldSet(this, _DownloadTask_fsHandle_accessor_storage, value, "f");
        }
        get total() {
            return $d278b456907e9c31$var$__classPrivateFieldGet(this, _DownloadTask_total_accessor_storage, "f");
        }
        set total(value) {
            $d278b456907e9c31$var$__classPrivateFieldSet(this, _DownloadTask_total_accessor_storage, value, "f");
        }
        get loaded() {
            return $d278b456907e9c31$var$__classPrivateFieldGet(this, _DownloadTask_loaded_accessor_storage, "f");
        }
        set loaded(value) {
            $d278b456907e9c31$var$__classPrivateFieldSet(this, _DownloadTask_loaded_accessor_storage, value, "f");
        }
        get percent() {
            return $d278b456907e9c31$var$__classPrivateFieldGet(this, _DownloadTask_percent_accessor_storage, "f");
        }
        set percent(value) {
            $d278b456907e9c31$var$__classPrivateFieldSet(this, _DownloadTask_percent_accessor_storage, value, "f");
        }
        get executing() {
            return $d278b456907e9c31$var$__classPrivateFieldGet(this, _DownloadTask_executing_accessor_storage, "f");
        }
        set executing(value) {
            $d278b456907e9c31$var$__classPrivateFieldSet(this, _DownloadTask_executing_accessor_storage, value, "f");
        }
        get options() {
            return $d278b456907e9c31$var$__classPrivateFieldGet(this, _DownloadTask_options_accessor_storage, "f");
        }
        set options(value) {
            $d278b456907e9c31$var$__classPrivateFieldSet(this, _DownloadTask_options_accessor_storage, value, "f");
        }
        get totalSize() {
            return new (0, $42h8L$ByteSize)(this.total);
        }
        get loadedSize() {
            return new (0, $42h8L$ByteSize)(this.loaded);
        }
        static nameOf(URI) {
            return decodeURI(new URL(URI).pathname.split("/").filter(Boolean).at(-1));
        }
        constructor(path, name = _a.nameOf(path)){
            _DownloadTask_id_accessor_storage.set(this, ($d278b456907e9c31$var$__runInitializers(this, _instanceExtraInitializers), $d278b456907e9c31$var$__runInitializers(this, _id_initializers, "")));
            _DownloadTask_name_accessor_storage.set(this, ($d278b456907e9c31$var$__runInitializers(this, _id_extraInitializers), $d278b456907e9c31$var$__runInitializers(this, _name_initializers, "")));
            _DownloadTask_path_accessor_storage.set(this, ($d278b456907e9c31$var$__runInitializers(this, _name_extraInitializers), $d278b456907e9c31$var$__runInitializers(this, _path_initializers, "")));
            _DownloadTask_fsHandle_accessor_storage.set(this, ($d278b456907e9c31$var$__runInitializers(this, _path_extraInitializers), $d278b456907e9c31$var$__runInitializers(this, _fsHandle_initializers, void 0)));
            _DownloadTask_total_accessor_storage.set(this, ($d278b456907e9c31$var$__runInitializers(this, _fsHandle_extraInitializers), $d278b456907e9c31$var$__runInitializers(this, _total_initializers, 0)));
            _DownloadTask_loaded_accessor_storage.set(this, ($d278b456907e9c31$var$__runInitializers(this, _total_extraInitializers), $d278b456907e9c31$var$__runInitializers(this, _loaded_initializers, 0)));
            _DownloadTask_percent_accessor_storage.set(this, ($d278b456907e9c31$var$__runInitializers(this, _loaded_extraInitializers), $d278b456907e9c31$var$__runInitializers(this, _percent_initializers, 0)));
            _DownloadTask_executing_accessor_storage.set(this, ($d278b456907e9c31$var$__runInitializers(this, _percent_extraInitializers), $d278b456907e9c31$var$__runInitializers(this, _executing_initializers, false)));
            _DownloadTask_options_accessor_storage.set(this, ($d278b456907e9c31$var$__runInitializers(this, _executing_extraInitializers), $d278b456907e9c31$var$__runInitializers(this, _options_initializers, void 0)));
            Object.defineProperty(this, "stream", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: $d278b456907e9c31$var$__runInitializers(this, _options_extraInitializers)
            });
            this.path = path;
            this.name = name;
        }
        toJSON() {
            const { id: id, name: name, path: path, fsHandle: fsHandle, total: total, loaded: loaded, percent: percent, options: options } = this;
            return Object.assign({
                id: id,
                name: name,
                path: path,
                fsHandle: fsHandle,
                options: options
            }, {
                total: total,
                loaded: loaded,
                percent: percent
            });
        }
        saveMeta(data = {}) {
            const { buffer: buffer } = data, progress = $d278b456907e9c31$var$__rest(data, [
                "buffer"
            ]);
            Object.assign(this, progress);
            return data;
        }
        start() {
            return $d278b456907e9c31$var$__awaiter(this, arguments, void 0, function*(options = this.options) {
                this.options = options;
                const started = Promise.withResolvers();
                const [innerStream, outerStream] = (yield $42h8L$webstreamspolyfill).ReadableStream.from(this.loadStream(options)).tee();
                (()=>$d278b456907e9c31$var$__awaiter(this, void 0, void 0, function*() {
                        var _b, e_1, _c, _d;
                        try {
                            try {
                                for(var _e = true, innerStream_1 = $d278b456907e9c31$var$__asyncValues(innerStream), innerStream_1_1; innerStream_1_1 = yield innerStream_1.next(), _b = innerStream_1_1.done, !_b; _e = true){
                                    _d = innerStream_1_1.value;
                                    _e = false;
                                    const chunk = _d;
                                    started.resolve();
                                    console.table(chunk);
                                }
                            } catch (e_1_1) {
                                e_1 = {
                                    error: e_1_1
                                };
                            } finally{
                                try {
                                    if (!_e && !_b && (_c = innerStream_1.return)) yield _c.call(innerStream_1);
                                } finally{
                                    if (e_1) throw e_1.error;
                                }
                            }
                        } catch (error) {
                            started.reject(error);
                        }
                    }))();
                yield started.promise;
                return this.stream = outerStream;
            });
        }
        pause() {
            return $d278b456907e9c31$var$__awaiter(this, void 0, void 0, function*() {
                this.executing = false;
            });
        }
        destroy() {
            return $d278b456907e9c31$var$__awaiter(this, void 0, void 0, function*() {
                yield this.pause();
                return (0, $400caf514fe4dd82$export$b1fb4cac938035f7)(this, this.id);
            });
        }
    }, _DownloadTask_id_accessor_storage = new WeakMap(), _DownloadTask_name_accessor_storage = new WeakMap(), _DownloadTask_path_accessor_storage = new WeakMap(), _DownloadTask_fsHandle_accessor_storage = new WeakMap(), _DownloadTask_total_accessor_storage = new WeakMap(), _DownloadTask_loaded_accessor_storage = new WeakMap(), _DownloadTask_percent_accessor_storage = new WeakMap(), _DownloadTask_executing_accessor_storage = new WeakMap(), _DownloadTask_options_accessor_storage = new WeakMap(), (()=>{
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
        _id_decorators = [
            (0, $400caf514fe4dd82$export$9a6132153fba2e0)(),
            (0, $42h8L$observable)
        ];
        _name_decorators = [
            (0, $400caf514fe4dd82$export$9a6132153fba2e0)(),
            (0, $42h8L$observable)
        ];
        _path_decorators = [
            (0, $400caf514fe4dd82$export$9a6132153fba2e0)(),
            (0, $42h8L$observable)
        ];
        _fsHandle_decorators = [
            (0, $400caf514fe4dd82$export$9a6132153fba2e0)(),
            (_b = (0, $42h8L$observable)).ref.bind(_b)
        ];
        _total_decorators = [
            (0, $400caf514fe4dd82$export$9a6132153fba2e0)(),
            (0, $42h8L$observable)
        ];
        _loaded_decorators = [
            (0, $400caf514fe4dd82$export$9a6132153fba2e0)(),
            (0, $42h8L$observable)
        ];
        _percent_decorators = [
            (0, $400caf514fe4dd82$export$9a6132153fba2e0)(),
            (0, $42h8L$observable)
        ];
        _executing_decorators = [
            (0, $42h8L$observable)
        ];
        _options_decorators = [
            (0, $400caf514fe4dd82$export$9a6132153fba2e0)(),
            (0, $42h8L$observable)
        ];
        _get_totalSize_decorators = [
            (0, $42h8L$computed)
        ];
        _get_loadedSize_decorators = [
            (0, $42h8L$computed)
        ];
        $d278b456907e9c31$var$__esDecorate(_a, null, _id_decorators, {
            kind: "accessor",
            name: "id",
            static: false,
            private: false,
            access: {
                has: (obj)=>"id" in obj,
                get: (obj)=>obj.id,
                set: (obj, value)=>{
                    obj.id = value;
                }
            },
            metadata: _metadata
        }, _id_initializers, _id_extraInitializers);
        $d278b456907e9c31$var$__esDecorate(_a, null, _name_decorators, {
            kind: "accessor",
            name: "name",
            static: false,
            private: false,
            access: {
                has: (obj)=>"name" in obj,
                get: (obj)=>obj.name,
                set: (obj, value)=>{
                    obj.name = value;
                }
            },
            metadata: _metadata
        }, _name_initializers, _name_extraInitializers);
        $d278b456907e9c31$var$__esDecorate(_a, null, _path_decorators, {
            kind: "accessor",
            name: "path",
            static: false,
            private: false,
            access: {
                has: (obj)=>"path" in obj,
                get: (obj)=>obj.path,
                set: (obj, value)=>{
                    obj.path = value;
                }
            },
            metadata: _metadata
        }, _path_initializers, _path_extraInitializers);
        $d278b456907e9c31$var$__esDecorate(_a, null, _fsHandle_decorators, {
            kind: "accessor",
            name: "fsHandle",
            static: false,
            private: false,
            access: {
                has: (obj)=>"fsHandle" in obj,
                get: (obj)=>obj.fsHandle,
                set: (obj, value)=>{
                    obj.fsHandle = value;
                }
            },
            metadata: _metadata
        }, _fsHandle_initializers, _fsHandle_extraInitializers);
        $d278b456907e9c31$var$__esDecorate(_a, null, _total_decorators, {
            kind: "accessor",
            name: "total",
            static: false,
            private: false,
            access: {
                has: (obj)=>"total" in obj,
                get: (obj)=>obj.total,
                set: (obj, value)=>{
                    obj.total = value;
                }
            },
            metadata: _metadata
        }, _total_initializers, _total_extraInitializers);
        $d278b456907e9c31$var$__esDecorate(_a, null, _loaded_decorators, {
            kind: "accessor",
            name: "loaded",
            static: false,
            private: false,
            access: {
                has: (obj)=>"loaded" in obj,
                get: (obj)=>obj.loaded,
                set: (obj, value)=>{
                    obj.loaded = value;
                }
            },
            metadata: _metadata
        }, _loaded_initializers, _loaded_extraInitializers);
        $d278b456907e9c31$var$__esDecorate(_a, null, _percent_decorators, {
            kind: "accessor",
            name: "percent",
            static: false,
            private: false,
            access: {
                has: (obj)=>"percent" in obj,
                get: (obj)=>obj.percent,
                set: (obj, value)=>{
                    obj.percent = value;
                }
            },
            metadata: _metadata
        }, _percent_initializers, _percent_extraInitializers);
        $d278b456907e9c31$var$__esDecorate(_a, null, _executing_decorators, {
            kind: "accessor",
            name: "executing",
            static: false,
            private: false,
            access: {
                has: (obj)=>"executing" in obj,
                get: (obj)=>obj.executing,
                set: (obj, value)=>{
                    obj.executing = value;
                }
            },
            metadata: _metadata
        }, _executing_initializers, _executing_extraInitializers);
        $d278b456907e9c31$var$__esDecorate(_a, null, _options_decorators, {
            kind: "accessor",
            name: "options",
            static: false,
            private: false,
            access: {
                has: (obj)=>"options" in obj,
                get: (obj)=>obj.options,
                set: (obj, value)=>{
                    obj.options = value;
                }
            },
            metadata: _metadata
        }, _options_initializers, _options_extraInitializers);
        $d278b456907e9c31$var$__esDecorate(_a, null, _get_totalSize_decorators, {
            kind: "getter",
            name: "totalSize",
            static: false,
            private: false,
            access: {
                has: (obj)=>"totalSize" in obj,
                get: (obj)=>obj.totalSize
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $d278b456907e9c31$var$__esDecorate(_a, null, _get_loadedSize_decorators, {
            kind: "getter",
            name: "loadedSize",
            static: false,
            private: false,
            access: {
                has: (obj)=>"loadedSize" in obj,
                get: (obj)=>obj.loadedSize
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    })(), _a;
})();


var $71107f2a0d00cd1d$var$__await = undefined && undefined.__await || function(v) {
    return this instanceof $71107f2a0d00cd1d$var$__await ? (this.v = v, this) : new $71107f2a0d00cd1d$var$__await(v);
};
var $71107f2a0d00cd1d$var$__asyncValues = undefined && undefined.__asyncValues || function(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
};
var $71107f2a0d00cd1d$var$__asyncGenerator = undefined && undefined.__asyncGenerator || function(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $71107f2a0d00cd1d$var$__await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
};

class $71107f2a0d00cd1d$export$54a5aef4e85ae85 extends (0, $d278b456907e9c31$export$e9ba70c733fe1cb8) {
    constructor(path, name){
        super(path, name);
        Object.defineProperty(this, "client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new (0, $42h8L$HTTPClient)({
                responseType: "arraybuffer"
            })
        });
        this.id = `http-download-task-${this.name}`;
        (0, $400caf514fe4dd82$export$db239ef39aadc7fe)(this, this.id);
    }
    loadStream(options) {
        return $71107f2a0d00cd1d$var$__asyncGenerator(this, arguments, function* loadStream_1() {
            var _a, e_1, _b, _c;
            const { path: path } = this;
            const suggestedName = (0, $d278b456907e9c31$export$e9ba70c733fe1cb8).nameOf(path);
            this.fsHandle || (this.fsHandle = yield $71107f2a0d00cd1d$var$__await((yield $71107f2a0d00cd1d$var$__await($42h8L$nativefilesystemadapter)).showSaveFilePicker({
                suggestedName: suggestedName
            })));
            const writer = yield $71107f2a0d00cd1d$var$__await(this.fsHandle.createWritable({
                keepExistingData: true
            })), stream = this.client.download(path, Object.assign({
                range: [
                    this.loaded
                ]
            }, options));
            try {
                this.executing = true;
                try {
                    for(var _d = true, stream_1 = $71107f2a0d00cd1d$var$__asyncValues(stream), stream_1_1; stream_1_1 = yield $71107f2a0d00cd1d$var$__await(stream_1.next()), _a = stream_1_1.done, !_a; _d = true){
                        _c = stream_1_1.value;
                        _d = false;
                        const chunk = _c;
                        yield $71107f2a0d00cd1d$var$__await(writer.write({
                            type: "write",
                            position: this.loaded,
                            data: chunk.buffer
                        }));
                        yield yield $71107f2a0d00cd1d$var$__await(this.saveMeta(chunk));
                        if (!this.executing) break;
                    }
                } catch (e_1_1) {
                    e_1 = {
                        error: e_1_1
                    };
                } finally{
                    try {
                        if (!_d && !_a && (_b = stream_1.return)) yield $71107f2a0d00cd1d$var$__await(_b.call(stream_1));
                    } finally{
                        if (e_1) throw e_1.error;
                    }
                }
            } finally{
                yield $71107f2a0d00cd1d$var$__await(writer.close());
                this.executing = false;
            }
        });
    }
}



var $5bda69183db6db33$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $5bda69183db6db33$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $5bda69183db6db33$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $5bda69183db6db33$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $5bda69183db6db33$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
let $5bda69183db6db33$export$ef06e7620d37c296 = (()=>{
    var _a, _Downloader_tasks_accessor_storage;
    let _instanceExtraInitializers = [];
    let _tasks_decorators;
    let _tasks_initializers = [];
    let _tasks_extraInitializers = [];
    let _get_unfinishedCount_decorators;
    let _get_executingCount_decorators;
    return _a = class Downloader {
        static createTask(path, name) {
            const [protocol] = path.split(":");
            const ProtocolTask = _a.protocolMap[protocol];
            if (!ProtocolTask) throw new URIError(`Protocol "${protocol} has not been registered"`);
            return new ProtocolTask(path, name);
        }
        constructor(){
            _Downloader_tasks_accessor_storage.set(this, ($5bda69183db6db33$var$__runInitializers(this, _instanceExtraInitializers), $5bda69183db6db33$var$__runInitializers(this, _tasks_initializers, [])));
            $5bda69183db6db33$var$__runInitializers(this, _tasks_extraInitializers);
            (0, $400caf514fe4dd82$export$db239ef39aadc7fe)(this, "downloader");
        }
        get tasks() {
            return $5bda69183db6db33$var$__classPrivateFieldGet(this, _Downloader_tasks_accessor_storage, "f");
        }
        set tasks(value) {
            $5bda69183db6db33$var$__classPrivateFieldSet(this, _Downloader_tasks_accessor_storage, value, "f");
        }
        get unfinishedCount() {
            return this.tasks.filter(({ percent: percent })=>percent < 100).length;
        }
        get executingCount() {
            return this.tasks.filter(({ executing: executing })=>executing).length;
        }
        createTask(path, name) {
            const { tasks: tasks } = this;
            const sameTask = tasks.find((task)=>task.path === path);
            if (sameTask) return sameTask;
            const task = _a.createTask(path, name);
            this.tasks = [
                ...tasks,
                task
            ];
            return task;
        }
        destroyTask(name) {
            return $5bda69183db6db33$var$__awaiter(this, void 0, void 0, function*() {
                const { tasks: tasks } = this;
                const index = tasks.findIndex(({ name: N })=>N === name);
                if (index < 0) throw new ReferenceError(`${name} isn't found`);
                yield tasks[index].destroy();
                this.tasks = [
                    ...tasks.slice(0, index),
                    ...tasks.slice(index + 1)
                ];
            });
        }
    }, _Downloader_tasks_accessor_storage = new WeakMap(), (()=>{
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
        _tasks_decorators = [
            (0, $400caf514fe4dd82$export$9a6132153fba2e0)({
                set: (tasks)=>tasks.map(({ name: name, path: path })=>({
                            name: name,
                            path: path
                        })),
                get: (list)=>list === null || list === void 0 ? void 0 : list.map(({ name: name, path: path })=>$5bda69183db6db33$export$ef06e7620d37c296.createTask(path, name))
            }),
            (0, $42h8L$observable)
        ];
        _get_unfinishedCount_decorators = [
            (0, $42h8L$computed)
        ];
        _get_executingCount_decorators = [
            (0, $42h8L$computed)
        ];
        $5bda69183db6db33$var$__esDecorate(_a, null, _tasks_decorators, {
            kind: "accessor",
            name: "tasks",
            static: false,
            private: false,
            access: {
                has: (obj)=>"tasks" in obj,
                get: (obj)=>obj.tasks,
                set: (obj, value)=>{
                    obj.tasks = value;
                }
            },
            metadata: _metadata
        }, _tasks_initializers, _tasks_extraInitializers);
        $5bda69183db6db33$var$__esDecorate(_a, null, _get_unfinishedCount_decorators, {
            kind: "getter",
            name: "unfinishedCount",
            static: false,
            private: false,
            access: {
                has: (obj)=>"unfinishedCount" in obj,
                get: (obj)=>obj.unfinishedCount
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $5bda69183db6db33$var$__esDecorate(_a, null, _get_executingCount_decorators, {
            kind: "getter",
            name: "executingCount",
            static: false,
            private: false,
            access: {
                has: (obj)=>"executingCount" in obj,
                get: (obj)=>obj.executingCount
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    })(), Object.defineProperty(_a, "protocolMap", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: {
            http: (0, $71107f2a0d00cd1d$export$54a5aef4e85ae85),
            https: (0, $71107f2a0d00cd1d$export$54a5aef4e85ae85)
        }
    }), _a;
})();
$parcel$exportWildcard($5bda69183db6db33$exports, $71107f2a0d00cd1d$exports);
$parcel$exportWildcard($5bda69183db6db33$exports, $d278b456907e9c31$exports);




export {$400caf514fe4dd82$export$e03c1c3201ee8bb7 as toggle, $400caf514fe4dd82$export$6287f85d0f6a9342 as toggleNotification, $400caf514fe4dd82$export$9a6132153fba2e0 as persist, $400caf514fe4dd82$export$db239ef39aadc7fe as restore, $400caf514fe4dd82$export$b1fb4cac938035f7 as destroy, $16892940cfb7bd51$export$d12e20a4eec10acf as BaseModel, $16892940cfb7bd51$export$673dbc4a8d0cb20a as BaseListModel, $5766c49bacaeb5b8$export$36e5777a1ba4b7c3 as ListModel, $5766c49bacaeb5b8$export$a143d493d941bafc as Buffer, $5766c49bacaeb5b8$export$6a4eb2e7fc9e8903 as Stream, $5bda69183db6db33$export$ef06e7620d37c296 as Downloader, $71107f2a0d00cd1d$export$54a5aef4e85ae85 as HTTPDownloadTask, $d278b456907e9c31$export$e9ba70c733fe1cb8 as DownloadTask};
//# sourceMappingURL=index.esm.js.map
